import {library} from '@fortawesome/fontawesome-svg-core';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

import {
  faAngleLeft,
  faAngleRight,
  faAngleDown,
  faBars,
  faCaretDown,
  faCircle,
  faCircleInfo,
  faDownload,
  faDownLong,
  faEdit,
  faEllipsis,
  faEllipsisVertical,
  faMagnifyingGlass,
  faQuestion,
  faUpload,
  faUpLong,
  faXmark,
  faCircleXmark,
  faCircleCheck,
  faFolder,
  faList,
  faClockRotateLeft,
  faTableLayout,
  faCircleSmall,
  faGear,
  faCircleQuestion,
  faFileExport,
  faUserGroup,
  faRotateRight,
  faHouseChimney,
  faDisplayArrowDown,
  faCloudArrowUp,
  faTrashCan,
  faCalendarDays,
  faSearch,
  faGrid,
  faStar,
  faArrowUp,
  faArrowDown,
  faCheck
} from '@fortawesome/pro-duotone-svg-icons';

library.add(
  faUpLong,
  faDownLong,
  faAngleDown,
  faCaretDown,
  faBars,
  faXmark,
  faCircleXmark,
  faEllipsis,
  faEdit,
  faEllipsisVertical,
  faQuestion,
  faCircleInfo,
  faCircle,
  faAngleLeft,
  faAngleRight,
  faMagnifyingGlass,
  faDownload,
  faUpload,
  faCircleCheck,
  faFolder,
  faList,
  faClockRotateLeft,
  faTableLayout,
  faCircleSmall,
  faGear,
  faCircleQuestion,
  faFileExport,
  faUserGroup,
  faRotateRight,
  faHouseChimney,
  faDisplayArrowDown,
  faCloudArrowUp,
  faTrashCan,
  faCalendarDays,
  faSearch,
  faGrid,
  faStar,
  faArrowUp,
  faArrowDown,
  faCheck
);

export default function registerFontAwesome(app) {
  app.component('FontAwesomeIcon', FontAwesomeIcon);
}
